export default "__VITE_ASSET__xfOQRmds__"